import { Icon as BpIcon, IconName } from "@blueprintjs/core";
import React, { ReactNode } from "react";
import { css } from "styled-components";
import styled from "styled-components";
import IconViewConfig from "./IconConfig";

interface IIconWrapperProps {
	config: IconViewConfig;
	hasChildren: boolean;
}

// eventually transition everywehre to pass icons as this object instead of strings
export interface IIcon {
	type: string; // "set"
	icon: string;
}

const IconWrapper = styled.div<IIconWrapperProps>(({config, hasChildren}) => css`

	color: ${config.color};

	& .icon-wrap {
		${"right" === config.iconPosition ? css`
			margin-left: ${config.iconMargin};
		` : css`
			margin-right: ${config.iconMargin};
		`}
	}

	${hasChildren && css`
		display: flex;
		align-items: center;
	` || css`
		display: inline-block;
	`}
`);

interface IIconProps<T extends "bp" | "external" = "bp"> {
	icon: T extends "bp" ? IconName : string;
	type?: T;
	config?: IconViewConfig;
}

const renderIcon = ({type, icon}: IIcon, config: IconViewConfig) => (
	type === 'external' ? <i className={icon} /> : <BpIcon icon={icon as IconName} iconSize={config.iconSize} />
);

export function Icon<T extends ("bp" | "external") = "bp">(props: {children?: ReactNode} & IIconProps<T>) {
	const {children, config = {} as IconViewConfig, icon} = props;

	const type = props.type || config.type || "bp";

	const iconElement = !!children ? (
		<span className="icon-wrap">
			{renderIcon({icon, type}, config)}
		</span>
	) : renderIcon({icon, type}, config);

	return (
		<IconWrapper config={config} hasChildren={!!children}>
			{(!config.iconPosition || "left" === config.iconPosition) && iconElement}

			{children}

			{"right" === config.iconPosition && iconElement}
		</IconWrapper>
	);
}

export default Icon;



// WEBPACK FOOTER //
// ./src/common/views/icon/Icon.tsx